//DEPLOY /*
import srcJson from "./json/AC_PLMP_Lender_Table_final_minV2.json"; // Comment this while deploying
//DEPLOY */
import axios from "axios";
import { Configuration } from "./Configuration"

// UnComment this while deploying
// Production only
//DEPLOY const srcJson = null; // Remove this when importing srcJson from json file
var srcNewJson = null;
let lenderOffersV2 = null; // flattenJsonForEachOffer();
//let prLicenses = null; //srcJson['pr-licenses'];
let prLenderIndex =  null;
let prLenderDetail = null;
let redirectUrl = null;
let affiliatesDetail = null;
let creditScorePopup = null;
let loanPuposePopup = null;
let ajaxEnpoint = null;
let sorts = null;
let trackGoalId = null;
let toggleImage = null;
if (Configuration.isLocalHost) {
    lenderOffersV2 = flattenJsonForEachOffer(srcJson);
    prLenderIndex = srcJson['pr-lender-index'];
    prLenderDetail = srcJson['pr-lender-detail'];
    redirectUrl = srcJson['redirect-page'];
    affiliatesDetail = srcJson['affiliates'];
    creditScorePopup = srcJson['creditScorePopup'];
    loanPuposePopup = srcJson['loanPuposePopup'];
    ajaxEnpoint = srcJson['ajaxEnpoint'];
    sorts = srcJson['sorts'];
    trackGoalId = srcJson['trackGoalId'];
    toggleImage = srcJson['toggleImage'];
}

function getJsonV2() {
    const promise=axios.request({
        method: "get",
        url: window.AcornPLMPJSONConfigPath,
        crossDomain: true
      })
   // const promise = axios.get(window.PLMPJSONConfigPath);
    return promise.then(result => {
        srcNewJson = result.data;
        lenderOffersV2 = flattenJsonForEachOffer(srcNewJson);
        prLenderIndex = srcNewJson['pr-lender-index'];
        redirectUrl = srcNewJson['redirect-page'];  
        prLenderDetail = srcNewJson['pr-lender-detail'];  
        affiliatesDetail = srcNewJson['affiliates']; 
        creditScorePopup = srcNewJson['creditScorePopup'];
        loanPuposePopup = srcNewJson['loanPuposePopup'];
        ajaxEnpoint = srcNewJson['ajaxEnpoint']; 
        sorts = srcNewJson['sorts'];
        trackGoalId = srcNewJson['trackGoalId'];
        toggleImage = srcNewJson['toggleImage'];
        return { lenderOffersV2: lenderOffersV2, prLenderIndex: prLenderIndex, prLenderDetail: prLenderDetail, redirectUrl: redirectUrl, ajaxEnpoint : ajaxEnpoint, trackGoalId : trackGoalId, toggleImage: toggleImage };
    });
}

function flattenJsonForEachOffer(src) {
    var destJson = {  "lenders": []  };
    src.lenders.forEach(lender => {
            let destlender = JSON.parse(JSON.stringify(lender));
            destJson.lenders.push(destlender);
    });
    return destJson;
}

export { getJsonV2, lenderOffersV2, prLenderIndex, prLenderDetail,affiliatesDetail,sorts, redirectUrl, creditScorePopup, ajaxEnpoint, loanPuposePopup, trackGoalId ,toggleImage};


// WEBPACK FOOTER //
// ./src/LoanOfferListV2.js